import styles from "./static-header.module.scss";

export default function StaticHeader() {
  return (
    <div className={styles.logoBar}>
      <a href="https://www.getclaimable.com/for-providers">
        <img
          className={styles.logo}
          src="/images/logo/logo_black_large.svg"
          alt="Claimable"
        />
      </a>
    </div>
  );
}
